<template>
  <v-container fluid class="background-color-prelude">
    <v-row justify="center">
      <v-footer
        color="#c7afd1"
        class="align-center d-flex font-size-sm justify-space-evenly"
        height="360"
      >
        <SupportDialog :close="close" :dialog="dialog" />
        <v-col cols="12" class="align-center d-flex justify-center">
          <router-link :to="{ name: 'about' }" v-if="!rewardsFormat">
            <span class="font-size-footer font-weight-semibold e2e-footer-about"
              >ABOUT</span
            >
          </router-link>
          <span v-if="!rewardsFormat" class="color-white mx-3">&#x02022;</span>
          <span
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            class="color-white font-size-footer font-weight-semibold e2e-footer-support"
            @click.stop="toSupport()"
            >SUPPORT</span
          >
          <span class="color-white mx-3">&#x02022;</span>

          <router-link
            v-if="authorized"
            class="color-white font-size-footer font-weight-semibold e2e-footer-account"
            :to="routeToAccount()"
            >ACCOUNT</router-link
          >

          <span
            v-else
            class="color-white font-size-footer font-weight-semibold e2e-footer-login"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            @click.stop="toLogin()"
            >LOG IN</span
          >
        </v-col>
        <v-row class="flex-column-reverse flex-md-row" no-gutters>
          <v-col
            cols="12"
            md="4"
            class="align-center d-flex flex-column pa-md-0"
          >
            <v-card
              class="hidden-sm-and-down height mb-2"
              color="white"
              max-width="380"
            >
              <!--
            <v-card-text>ADVERTISEMENT BLOCK 380px X 130px</v-card-text>
              -->
              <a :href="NRS_PAY" target="_blank" rel="noreferrer">
                <img
                  src="@/assets/ads/nrs_pay_ad.gif"
                  height="130"
                  class="ad"
                />
              </a>
            </v-card>
            <div class="color-white text-center">
              Copyright &copy; {{ new Date().getFullYear() }} National Retails
              Solutions, Inc.
            </div>
            <div class="color-white text-center">All Rights Reserved.</div>
          </v-col>
          <v-col cols="12" md="4" class="align-center d-flex flex-column pa-0">
            <a
              :href="NRS_PLUS"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                alt="logo"
                class="mb-2"
                height="130"
                width="100"
                src="@/assets/logo/footer/nrslogovectorallwhitestacked.svg"
              />
            </a>
            <div>
              <div class="color-white text-center">
                This Web Store is Powered by
              </div>
              <div class="color-white font-weight-semibold text-center">
                <a :href="NRS_PLUS" target="_blank" rel="noopener noreferrer"
                  >National Retail Solutions, Inc</a
                >
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="align-center d-flex flex-column pa-0">
            <v-card
              class="hidden-sm-and-down height height mb-2"
              color="white"
              max-width="380"
            >
              <!--
            <v-card-text>ADVERTISEMENT BLOCK 380px X 130px</v-card-text>
              -->
              <a :href="BOSS_REVOLUTION" target="_blank" rel="noreferrer">
                <img
                  src="@/assets/ads/boss_rev_ad.gif"
                  height="130"
                  class="ad"
                />
              </a>
            </v-card>
            <div class="hidden-sm-and-down">
              <LegalLinks />
            </div>
          </v-col>
          <SocialMedia color="white" />
        </v-row>
      </v-footer>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import LegalLinks from "@/components/UI/LegalLinks.vue";
import SocialMedia from "@/components/UI/SocialMedia.vue";
import SupportDialog from "@/components/Support/Dialog.vue";
import urls from "@/urls.json";

export default {
  name: "Footer",
  components: { LegalLinks, SocialMedia, SupportDialog },
  computed: {
    ...mapGetters("auth", { authorized: "isAuthenticated" }),
    ...mapGetters("store", { rewardsFormat: "rewardsFormat" }),
  },
  created() {
    this.NRS_PAY = urls.NRS_PAY;
    this.NRS_PLUS = urls.NRS_PLUS;
    this.BOSS_REVOLUTION = urls.BOSS_REVOLUTION;
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    close() {
      this.dialog = !this.dialog;
    },
    openLoginDialog() {
      this.$store.commit("auth/OPEN", true);
    },
    openSupportDialog() {
      this.dialog = true;
    },
    routeToAccount() {
      const smAndUpAccountRoute = {
        name: "account",
        hash: "#profile",
        params: { view: "My Profile" },
      };
      const xsAccountRoute = { name: "account" };
      return this.$vuetify.breakpoint.xsOnly
        ? xsAccountRoute
        : smAndUpAccountRoute;
    },
    routeToLoginView() {
      this.$router.push({ name: "login" });
    },
    routeToSupportView() {
      this.$router.push({ name: "support" });
    },
    toLogin() {
      this.$vuetify.breakpoint.xsOnly
        ? this.routeToLoginView()
        : this.openLoginDialog();
    },
    toSupport() {
      this.$vuetify.breakpoint.xsOnly
        ? this.routeToSupportView()
        : this.openSupportDialog();
    },
  },
};
</script>

<style scoped>
/* unvisited link */
a:link {
  color: var(--color-white);
}

/* visited link */
a:visited {
  color: var(--color-white);
}

/* mouse over link */
a:hover {
  color: var(--color-white);
}

/* selected link */
a:active {
  color: var(--color-white);
}

.ad {
  width: 100%;
  max-width: 248px;
}
@media (min-width: 1264px) {
  .ad {
    max-width: 348px;
  }
}
@media (min-width: 1904px) {
  .ad {
    max-width: 380px;
  }
}

.font-size-footer {
  font-size: 1.125rem; /* 18px */
}

.height {
  height: 130px;
}
</style>
